import React from 'react';

function CTA() {
  return (
    <section className="cta-section">
      <div className="wrap">
        <div className="cta-box reveal">
          {/* Floating decorations */}
          <span className="cta-float cta-float-1">🖌️</span>
          <span className="cta-float cta-float-2">🎯</span>
          <span className="cta-float cta-float-3">⭐</span>

          <div className="cta-inner">
            <span className="cta-emoji">🎨</span>
            <h2 className="cta-h2">
              Ready to draw, guess,
              <br />
              and have a blast?
            </h2>
            <p className="cta-p">
              Download PictureIt and challenge your friends to the ultimate
              drawing showdown. It's free!
            </p>
            <div className="cta-btns">
              <a href="#platforms" className="btn btn-hero-primary">
                <span className="btn-icon">📲</span> Download Now
              </a>
              <a href="#features" className="btn btn-hero-secondary">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;